import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { createCompanyShareToken } from './queryFn';

export const useCreateCompanyShareToken = () => {
  const { addSnackbar } = useSnackbar();

  const { mutate, status } = useMutation({
    mutationFn: createCompanyShareToken,
    onError: () => {
      addSnackbar({
        type: 'negative',
        message:
          'Maximum number of share links per month reached. Please contact support',
        lifeTime: 4000,
      });
    },
  });

  return { mutate, status };
};
